// isCordova = isCordova || true

let portraitListener = null;
let portraitQuery = window.matchMedia('(orientation: portrait)');
let isCordova = navigator.userAgent.indexOf("(cordova)")>=0;
export default {
    isCordova() {
        return isCordova;
    },
    isIOS() {
        return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0
    },
    isAndroid() {
        return navigator.userAgent.toLowerCase().indexOf("android") >= 0
    },
    isPortrait(onchange){
        if(onchange){
            portraitListener && portraitQuery.removeListener(portraitListener);
            portraitQuery.addListener(portraitListener = onchange)
        }
        return portraitQuery.matches;
    },
    async init() {
        if (!this.isCordova() || window.Cordova) return;

        let sysFile = window.File;
        await new Promise((o, x) => {
            let s = document.createElement("script");
            if (this.isAndroid())
                s.src = "cdvfile://localhost/assets/www/cordova.js";
            else if (this.isIOS())
                s.src = "cdvfile://localhost/bundle/www/cordova.js";
            s.onload = () => {
                document.addEventListener("deviceready", o);
            };
            s.onerror = x;
            document.head.append(s);
        });
        //cordova-plugin-file 会覆盖 window.File 导致上传组件(stream-v1.js)错误
        window.File = sysFile;

    },
    clearUser(){
        if(!isCordova)return;
        localStorage.removeItem("cordova_item")
    },
}
